/** Lista de customers permitidos a acessar uma determinada pasta. */
const folderAllowedCustomers: Record<string, string[]> = {
  casadamontanha: [
    'casahoteis',
    'casadamontanha',
    'paradorcasadamontanha',
    'petitcasadamontanha',
    'vinolab',
    'hotelwood',
    'homolog',
  ],
  atlantica: ['atlantica', 'homolog'],
};

const casaFonts = ['DIN', 'DINPro', 'DINPro Condensed', 'Archive Regular'];

const atlanticaFonts = [
  'Alber',
  'AvenirLTPro',
  'Geomanist',
  'Gesta',
  'Gilroy',
  'Gotham',
  'Gotham Narrow',
  'Gotham Extra Narrow',
  'Gotham Rounded',
  'Knockout HTF49 LiteWeight',
  'Miller Text',
  'Mont',
  'Proxima Nova Condensed',
  'Proxima Nova Extra Condensed',
  'Sentinel',
  'Sofia Pro',
  'Stag',
  'Trade Gothic',
  'Usual',
  'Usual BreeSerif',
  'Verdana',
];

/** Retorna a lista de fontes exclusivas disponíveis para o customer */
export function getCustomerFontList(customer: string): string[] {
  const fonts: string[] = [];
  const folderFonts: Record<string, string[]> = {
    casadamontanha: casaFonts,
    atlantica: atlanticaFonts,
  };

  for (const [folder, customers] of Object.entries(folderAllowedCustomers)) {
    if (customers.includes(customer)) {
      fonts.push(...folderFonts[folder]);
    }
  }

  return fonts;
}

/**
 * Carrega fontes exclusivas de um cliente de forma condicional,
 * injetando um <link> no <head> apenas quando necessário.
 *
 * Deve ser chamado após o customer ser identificado (ex: no router guard).
 */
export function loadClientFonts(customer: string): void {
  for (const [folder, customers] of Object.entries(folderAllowedCustomers)) {
    if (!customers.includes(customer)) continue;

    const linkId = `client-fonts-${folder}`;
    if (document.getElementById(linkId)) continue;

    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = `/fonts/${folder}/_fonts.css`;
    document.head.appendChild(link);
  }
}
